import {
  Paper,
  Typography,
  Button,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import { MouseEvent } from "react";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent, { TablePropType } from "../../component/TableComponent";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import {
  insurancWiseClaimReport,
  insurancWiseClaimReportPdf,
  insurancWiseClaimReportExcel,
} from "../services";
import { FormOnChangeEventType } from "../../../EMR/types";
import {
  getInsuranceByParams,
  getInsuranceType,
} from "../../../Insurance/services";
import moment from "moment";
import { ClaimSearchFormType, initialData } from "../types";
const today = moment(new Date()).format("yyyy-MM-DD");
const fieldsForClear = ["insuranceType", "receiver", "payer"];
function InsuranceWiseClaimReport() {
  const { watch, control, getValues, resetField, reset, handleSubmit } =
    useForm<ClaimSearchFormType>({
      defaultValues: initialData,
    });

  const { mutate: getPdfFile, isLoading: pdfLoading } = useRepotFile({
    apiFunction: insurancWiseClaimReportPdf,
    responseFileKey: "file",
  });
  const { mutate: getExcelFile, isLoading: excelLoading } = useRepotFile({
    apiFunction: insurancWiseClaimReportExcel,
    fileType: "xlsx",
  });

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    const formData = {
      startDate: allData.fromDate,
      endDate: allData.toDate,
      insuranceType: allData?.insuranceType?.name || "",
      receiver: allData?.receiver?.name || allData?.payer?.name || null,
      payer: allData?.payer?.name || null,
    };
    if (fileType === "pdf") {
      getPdfFile(formData);
    } else {
      getExcelFile(formData);
    }
  };

  const insType = watch("insuranceType");

  const { data: insuranceType, isLoading: insuranceTypeLoading } = useQuery(
    ["insuranceTypesForInsuranceWiseClaimReport"],
    getInsuranceType,
    { refetchOnWindowFocus: false }
  );

  const {
    mutate: getReveiverByType,
    data: receiverData,
    isLoading: receiverLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: getPayerByType,
    data: payerData,
    isLoading: payerLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: search,
    isLoading: tableDataLoading,
    data: tableData,
    reset: resetMutation,
  } = useMutation(insurancWiseClaimReport, {
    onSuccess: (result) => {
      if (result.responseIndicator == "fail") {
      }
    },
  });

  const clearField = (index: number) => {
    for (let i = index; i < fieldsForClear.length; i++) {
      resetField(fieldsForClear[i] as keyof typeof initialData);
    }
  };

  function onSubmit(value: ClaimSearchFormType) {
    const formData = {
      startDate: value.fromDate,
      endDate: value.toDate,
      insuranceType: value?.insuranceType?.name || "",
      receiver: value?.receiver?.name || value?.payer?.name || "",
      payer: value?.payer?.name || "",
    };
    search(formData);
  }

  const handleInsurnceTypeChange = (params: FormOnChangeEventType) => {
    const {
      target: { value },
    } = params;
    clearField(1);
    const allData = watch();
    if (Boolean(value)) {
      if (value.id == 1) {
        getReveiverByType({ typeId: value.id });
      } else {
        getPayerByType({ typeId: value.id });
      }
      reset({
        ...allData,
        receiver: null,
        payer: null,
      });
    } else {
      reset({
        ...allData,
        insuranceType: null,
        receiver: null,
        payer: null,
      });
    }
  };

  const handleReset = () => {
    resetMutation();
    reset(initialData);
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Insurance Wise Claim Report
          </Typography>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-4 gap-3 p-4"
        >
          <div>
            <CustomFormField
              control={control}
              element="datepicker"
              name="fromDate"
              fieldProps={{ label: "From Date", inputProps: { max: today } }}
              rules={{ required: "From date required" }}
            />
          </div>
          <div>
            <CustomFormField
              control={control}
              element="datepicker"
              name="toDate"
              fieldProps={{ label: "To Date" }}
              rules={{ required: "To date required" }}
            />
          </div>
          <div>
            <CustomFormField
              control={control}
              options={insuranceType?.response || []}
              loading={insuranceTypeLoading}
              element="autocomplete"
              name="insuranceType"
              fieldProps={{ label: "Insurance Type" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              rules={{
                required: "Insurance Type required",
                onChange: handleInsurnceTypeChange,
              }}
            />
          </div>
          <div className={insType?.id == 1 ? "" : "hidden"}>
            <CustomFormField
              control={control}
              options={receiverData?.response || []}
              loading={receiverLoadig}
              element="autocomplete"
              name="receiver"
              fieldProps={{ label: "Receiver" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              rules={{
                required: insType?.id == 1 ? "Receiver required" : false,
                onChange: () => {
                  clearField(2);
                  getPayerByType({ typeId: 2 });
                },
              }}
            />
          </div>
          <div className="">
            <CustomFormField
              control={control}
              options={payerData?.response || []}
              loading={payerLoadig}
              element="autocomplete"
              name="payer"
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              fieldProps={{
                label: insType?.id == 1 ? "Payer" : "Insurance",
              }}
              rules={{
                required:
                  insType?.id == 1 ? "Payer required" : "Insurance required",
              }}
            />
          </div>

          <div
            className={
              insType?.id == 1
                ? "col-span-3 flex justify-end gap-2 items-center"
                : "col-span-4 flex justify-end gap-2 items-center"
            }
          >
            <Button
              endIcon={
                tableDataLoading && (
                  <CircularProgress
                    sx={{ color: (theme) => theme.palette.background.paper }}
                    size={18}
                  />
                )
              }
              size="small"
              type="submit"
            >
              Search
            </Button>
            <Button
              onClick={handleReset}
              size="small"
              type="reset"
              color="error"
            >
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={pdfLoading || !Boolean(tableData?.response?.length)}
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          <Button
            disabled={excelLoading || !Boolean(tableData?.response?.length)}
            endIcon={excelLoading && <CircularProgress size={18} />}
            data-filetype="excel"
            onClick={getFiles}
          >
            excel
          </Button>
        </div>
        <TableComponent
          loading={tableDataLoading}
          data={tableData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
}

export default InsuranceWiseClaimReport;

const heading:TablePropType = [
  { heading: "Patient Name", key: "patName" },
  { heading:   "EMR No/Reg No",key: "emrNo" },
  { heading: "Contact", key: "contact" },
  { heading: "Claim status", key: "claimStatus" },
  { heading: "Denial code", key: "rejAcptReason" },
  { heading: "Submission status", key: "submissionStatus" },
  { heading: "Submission type", key: "submissionType" },
  { heading: "Insurance share", key: "insShare" },
  { heading: "Patient share", key: "patShare" },
  { heading: "Received amount", key: "receivedAmount" },
  {
    heading: "Created date",
    key: "createdByDate",
    date: "DD-MM-YYYY hh:mm A",
    format: "YYYY-MM-DDTHH:mm:ss",
  },
];
